export default __webpack_public_path__ + "static/media/b_1.518eb3cd.jpg";